// =======================
// src/index.js
// =======================
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CondicaoProvider } from "./contexto";
import { FonteProvider } from "./contextos/FonteContext";
import App from "./App";
import ManutencaoGate from "./componentes/manutencao/ManutencaoGate";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ManutencaoGate>
      <CondicaoProvider>
        <FonteProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </FonteProvider>
      </CondicaoProvider>
    </ManutencaoGate>
  </React.StrictMode>,
);
